import {
  login,
  runLogoutTimer,
  saveTokenInLocalStorage,
} from "../../services/AuthService";

export const LOGIN_CONFIRMED_ACTION = "[login action] confirmed login";
export const LOGIN_FAILED_ACTION = "[login action] failed login";
export const LOADING_TOGGLE_ACTION = "[Loading action] toggle loading";
export const LOGOUT_ACTION = "[Logout action] logout action";

export function Logout(navigate) {
  localStorage.removeItem("userDetails");
  navigate("/login");
  return {
    type: LOGOUT_ACTION,
  };
}

export function loginAction(email, password, navigate) {
  return (dispatch) => {
    login(email, password)
      .then((response) => {
        let data = response.data;
        data.expiresIn = 6000;
        saveTokenInLocalStorage(data);
        runLogoutTimer(dispatch, data.expiresIn * 1000, navigate);
        dispatch(loginConfirmedAction(data));
        navigate("/students");
      })
      .catch((error) => {
        const errorMessage =
          error.response.data?.error == "Invalid credentials"
            ? "Los datos ingresados no son correctos"
            : "Ocurrio un error, por favor intenta mas tarde";
        dispatch(loginFailedAction(errorMessage));
      });
  };
}

export function loginFailedAction(data) {
  return {
    type: LOGIN_FAILED_ACTION,
    payload: data,
  };
}

export function loginConfirmedAction(data) {
  return {
    type: LOGIN_CONFIRMED_ACTION,
    payload: data,
  };
}

export function loadingToggleAction(status) {
  return {
    type: LOADING_TOGGLE_ACTION,
    payload: status,
  };
}
